module.exports = __webpack_public_path__ + "static/img/北科.2d0e808.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/北科.jpg
// module id = 3DFg
// module chunks = 1